export default class ListManipulator{
    constructor(){
        this.variance = 1;
        this._stabilityList = [
            "very understable", "understable", "neutral", "stable", "overstable", "very overstable"
        ];
    }

    GetSpeedMatches(list, searchObj){
        let speedMatches = list.filter((disc) => disc.speed <= searchObj.speed + this.variance
            && disc.speed >= searchObj.speed - this.variance);
        return speedMatches;
    }

    // FilterSkillMatches(list, searchObj){
    //     return list.filter((disc) => this.IncludedInSearchObjSkill(searchObj, disc));
    // }

    // IncludedInSearchObjSkill(searchObj, disc)
    // {
    //     if(searchObj.skill.includes(","))
    //     {
    //         const skillArr = searchObj.skill.split(",");
    //         skillArr.forEach((e) => e.trim());
    //         if(disc.skill.includes(","))
    //         {
    //             const discArr = disc.skill.split(",");
    //             discArr.forEach(e => e.trim());
    //             skillArr.forEach(e => {
    //                 if(discArr.findIndex(m => m == e)){
    //                     return true;
    //                 }
    //             })
    //             return false;
    //         }
    //         else
    //         {
    //             skillArr.forEach(e => {
    //                 if(disc.skill.includes(e)){
    //                     return true;
    //                 }
    //             })
    //             return false;
    //         }
    //     }
    //     else if(disc.skill.includes(searchObj.skill.trim()))
    //     {
    //         return true;
    //     }
    //     else
    //     {
    //         return false;
    //     }
    // }

    GetGlideMatches(list, searchObj){
        let glideMatches = list.filter((disc) => disc.glide <= searchObj.glide + this.variance
            && disc.glide >= searchObj.glide - this.variance);
        return glideMatches;
    }

    GetTurnMatches(list, searchObj){
        let turnMatches = list.filter((disc) => disc.turn <= searchObj.turn +this.variance
            && disc.turn >= searchObj.turn - this.variance);
        return turnMatches;
    }

    GetFadeMatches(list, searchObj)
    {
        return list.filter((disc) => disc.fade <= searchObj.fade + this.variance
            && disc.fade >= searchObj.fade - this.variance);
    }

    GetStabilityMatches(list, searchObj)
    {
        const searchStabIndex = this._stabilityList.findIndex(e => e == searchObj.stability.toLowerCase());
        if (searchStabIndex == this._stabilityList.length - 1)
        {
            return list.filter((disc) => disc.stability.toLowerCase() == this._stabilityList[searchStabIndex]
                || disc.stability.toLowerCase() == this._stabilityList[searchStabIndex -1])
        }
        else if (searchStabIndex == 0)
        {
            return list.filter((disc) => disc.stability.toLowerCase() == this._stabilityList[searchStabIndex]
                || disc.stability.toLowerCase() == this._stabilityList[searchStabIndex + 1])
        }
        else
        {
            return list.filter((disc) => disc.stability.toLowerCase() == this._stabilityList[searchStabIndex]
                || disc.stability.toLowerCase() == this._stabilityList[searchStabIndex -1]
                || disc.stability.toLowerCase() == this._stabilityList[searchStabIndex +1])
        }
    }

    // method accepts a list and object then finds matches for that object in the list
    GetMatches(list, searchObj){
        if(searchObj != {}){
            if(searchObj.id == null || searchObj.id == undefined)
            {
                return list;
            }
            else
            {
                let stability = this.GetStabilityMatches(list, searchObj);
                let speed = this.GetSpeedMatches(stability, searchObj);
                let glide = this.GetGlideMatches(speed, searchObj);
                let turn = this.GetTurnMatches(glide, searchObj);
                let fade = this.GetFadeMatches(turn, searchObj);
                return fade;
            }
        }
    }
}